import script from "./quizz-awards.vue?vue&type=script&setup=true&lang=ts"
export * from "./quizz-awards.vue?vue&type=script&setup=true&lang=ts"

import "./quizz-awards.vue?vue&type=style&index=0&id=1c3095a7&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3095a7"]])

export default __exports__